import groq from 'groq';

import { PRODUCT_SLUG } from '../product';
import { ASSET } from './asset';
import { CLOUDINARY_VIDEO } from './cloudinaryVideo';

export const SOCIAL_MEDIA_STORY = groq`
  _type,
  handle,
  url,
  "video": { ${CLOUDINARY_VIDEO} },
  poster { ${ASSET} },
  product-> { ${PRODUCT_SLUG} },
  pullQuote
`;
